module.exports = __webpack_public_path__ + "img/BoD_06_Mr_Fong_Heng_Bee.894e52d0.jpg";